import type { ImmerStateCreator } from 'hooks/useStore';

export interface SplashScreenSlice {
  showSplashScreen: boolean;
  setShowSplashScreenOpen: (open: boolean) => void;
}

export const useSplashScreenSlice: ImmerStateCreator<SplashScreenSlice> = (
  set
) => ({
  showSplashScreen: false,
  setShowSplashScreenOpen: (open: boolean) =>
    set(
      (state) => {
        state.splashScreenSlice.showSplashScreen = open;
      },
      false,
      'setShowSplashScreenOpen'
    ),
});
